var map = {
	"./blkf.scss": 124,
	"./imm.scss": 125,
	"./mlh.scss": 126,
	"./simia.scss": 127,
	"./vizsgeu.scss": 128
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;



//////////////////
// WEBPACK FOOTER
// ./src/assets/skins ^\.\/.*\.scss$
// module id = 166
// module chunks = 0